import React from "react";
import { Modal } from "react-bootstrap";
import crossIcon from "../../../images/svg/deleteIcon.svg";

export default function FullImage({ show, image, onHide, imageType }) {
  return (
    <Modal
      className="modal fade image-modal"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header className="border-0 w-100">
        <div className="image-container w-100" role="document">
          <div className="position-relative">
            <img
              src={crossIcon}
              alt="Cross Icon"
              className={`cross-icon pointer `}
              onClick={() => onHide()}
            />
            {imageType === "image" ? (
              <img
                src={image}
                alt="Image"
                className="rounded"
                style={{
                  transition: "width 0.5s, height 0.5s",
                  width: "100%",
                  height: "500px",
                  objectFit: "contain",
                }}
                onClick={() => onHide()}
              />
            ) : (
              <video
                controls
                muted
                autoPlay
                style={{
                  width: "100%",
                  height: "500px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  display: "block",
                }}
                width="385"
                height="400"
              >
                <source src={image} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      </Modal.Header>
    </Modal>
  );
}
